let vars = {};

vars.html = document.querySelector('html');
vars.body = document.querySelector('body');
vars.header = document.querySelector('header');
vars.menu = document.querySelector('menu');
vars.home = document.querySelector('.home');
vars.popup = document.querySelector('.popup');
vars.isMobile = () => innerWidth <= 739;
vars.isTablet = () => innerWidth >= 740 && innerWidth <= 1024;
vars.isDesktop = () => innerWidth >= 1025;
vars.winWidth = window.innerWidth;

vars.getRandom = (min, max) => {
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

vars.regex = {
	name: /^([a-zA-Zа-яА-Я ]){1,100}$/,
	email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export default vars;
